/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AddressDtoFromJSON, AddressDtoToJSON, } from './AddressDto';
import { BountyEscrowStatusFromJSON, BountyEscrowStatusToJSON, } from './BountyEscrowStatus';
import { BountyLocationFromJSON, BountyLocationToJSON, } from './BountyLocation';
import { IncidentReportTypeFromJSON, IncidentReportTypeToJSON, } from './IncidentReportType';
import { ModerationStatusFromJSON, ModerationStatusToJSON, } from './ModerationStatus';
/**
 * Check if a given object implements the SubmitBountyResponse interface.
 */
export function instanceOfSubmitBountyResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function SubmitBountyResponseFromJSON(json) {
    return SubmitBountyResponseFromJSONTyped(json, false);
}
export function SubmitBountyResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCode': !exists(json, 'countryCode') ? undefined : json['countryCode'],
        'location': !exists(json, 'location') ? undefined : BountyLocationFromJSON(json['location']),
        'address': !exists(json, 'address') ? undefined : AddressDtoFromJSON(json['address']),
        'windowStartDateTime': !exists(json, 'windowStartDateTime') ? undefined : (json['windowStartDateTime'] === null ? null : new Date(json['windowStartDateTime'])),
        'windowEndDateTime': !exists(json, 'windowEndDateTime') ? undefined : (json['windowEndDateTime'] === null ? null : new Date(json['windowEndDateTime'])),
        'windowTimezone': !exists(json, 'windowTimezone') ? undefined : json['windowTimezone'],
        'incidentReportType': !exists(json, 'incidentReportType') ? undefined : IncidentReportTypeFromJSON(json['incidentReportType']),
        'requestDescription': !exists(json, 'requestDescription') ? undefined : json['requestDescription'],
        'additionalInformation': !exists(json, 'additionalInformation') ? undefined : json['additionalInformation'],
        'rewardAmountPoints': !exists(json, 'rewardAmountPoints') ? undefined : json['rewardAmountPoints'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
        'expiresAt': !exists(json, 'expiresAt') ? undefined : (new Date(json['expiresAt'])),
        'moderationStatus': !exists(json, 'moderationStatus') ? undefined : ModerationStatusFromJSON(json['moderationStatus']),
        'isClaimed': !exists(json, 'isClaimed') ? undefined : json['isClaimed'],
        'isPaidInFull': !exists(json, 'isPaidInFull') ? undefined : json['isPaidInFull'],
        'escrowedPoints': !exists(json, 'escrowedPoints') ? undefined : json['escrowedPoints'],
        'escrowStatus': !exists(json, 'escrowStatus') ? undefined : BountyEscrowStatusFromJSON(json['escrowStatus']),
    };
}
export function SubmitBountyResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'countryCode': value.countryCode,
        'location': BountyLocationToJSON(value.location),
        'address': AddressDtoToJSON(value.address),
        'windowStartDateTime': value.windowStartDateTime === undefined ? undefined : (value.windowStartDateTime === null ? null : value.windowStartDateTime.toISOString()),
        'windowEndDateTime': value.windowEndDateTime === undefined ? undefined : (value.windowEndDateTime === null ? null : value.windowEndDateTime.toISOString()),
        'windowTimezone': value.windowTimezone,
        'incidentReportType': IncidentReportTypeToJSON(value.incidentReportType),
        'requestDescription': value.requestDescription,
        'additionalInformation': value.additionalInformation,
        'rewardAmountPoints': value.rewardAmountPoints,
        'id': value.id,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
        'expiresAt': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'moderationStatus': ModerationStatusToJSON(value.moderationStatus),
        'isClaimed': value.isClaimed,
        'isPaidInFull': value.isPaidInFull,
        'escrowedPoints': value.escrowedPoints,
        'escrowStatus': BountyEscrowStatusToJSON(value.escrowStatus),
    };
}
